import { defineStore } from 'pinia';
import { useFetch } from '#app';
import type { IPermissionsAll, ISubUsers, IUsersListDefineStore } from '~/types/users/List';
import { useToastStore } from "@/stores/toast";

export const useUsersListStore = defineStore('UsersListStore', {
    state: (): IUsersListDefineStore => ({
        error: null,
        subUsers: null,
        permissionsAll: null,
    }),
    getters: {},
    actions: {
        async getSubUsers() {
            const toastStore = useToastStore();
            try {
                const { data, error } = await useFetch<ISubUsers[]>('/api/users/list/subUsers');
                this.error = error;
                if (error && error.value?.statusCode) {
                    throw error;
                }

                this.subUsers = data.value;
                return true
            } catch (err: any) {
                this.error = err;
                toastStore.showAlert({
                    title: "Can Not Connect To Server",
                    showCloseButton: true,
                    timerProgressBar: true,
                    type: "error"
                });
                return false
            }
        },
        async subusersNewPassword(params: ISubUsers) {
            const toastStore = useToastStore();
            try {
                const { error } = await useFetch<any>('/api/users/list/subusersNewPassword', {
                    method: 'POST',
                    body: params
                });
                this.error = error;
                if (error && error.value?.statusCode) {
                    throw error;
                }

                return true
            } catch (err: any) {
                this.error = err;
                toastStore.showAlert({
                    title: "Can Not Connect To Server",
                    showCloseButton: true,
                    timerProgressBar: true,
                    type: "error"
                });
                return false
            }
        },
        async putSubUsersRole(params: ISubUsers) {
            const toastStore = useToastStore();
            try {
                const { error } = await useFetch<any>('/api/users/list/subusersRolePut', {
                    method: 'PUT',
                    body: params
                });
                this.error = error;
                if (error && error.value?.statusCode) {
                    throw error;
                }
                // toastStore.showAlert({
                //     title: "SubUsers Update Successfully",
                //     showCloseButton: true,
                //     timerProgressBar: true,
                // });
                return true
            } catch (err: any) {
                this.error = err;
                toastStore.showAlert({
                    title: "Can Not Connect To Server",
                    showCloseButton: true,
                    timerProgressBar: true,
                    type: "error"
                });
                return false
            }
        },

        async postNavaNumber(params: ISubUsers) {
            const toastStore = useToastStore();
            try {
                const { error, data } = await useFetch<any>('/api/users/list/navaNumberPost', {
                    method: 'POST',
                    body: params
                });
                this.error = error;
                if (error && error.value?.statusCode) {
                    throw error;
                }

                // await this.getSubUsers();
                if(data.value.guid) {
                    toastStore.showAlert({
                        title: "SubUsers Insert Successfully",
                        showCloseButton: true,
                        timerProgressBar: true,
                    });
                } else {
                    throw new Error("");
                }
                return true
            } catch (err: any) {
                this.error = err;
                toastStore.showAlert({
                    title: "Can Not Connect To Server",
                    showCloseButton: true,
                    timerProgressBar: true,
                    type: "error"
                });
                return false
            }
        },
        async deleteNavaNumber(params: ISubUsers) {
            const toastStore = useToastStore();
            try {
                const { error } = await useFetch<any>('/api/users/list/navaNumberDelete', {
                    method: 'DELETE',
                    body: params
                });
                this.error = error;
                if (error && error.value?.statusCode) {
                    throw error;
                }

                this.subUsers = this.subUsers?.filter(item => item.phoneNumber != params.phoneNumber);
                // toastStore.showAlert({
                //     title: "SubUsers Delete Successfully",
                //     showCloseButton: true,
                //     timerProgressBar: true,
                // });
                return true
            } catch (err: any) {
                this.error = err;
                toastStore.showAlert({
                    title: "Can Not Connect To Server",
                    showCloseButton: true,
                    timerProgressBar: true,
                    type: "error"
                });
                return false
            }
        },
        
        async getPermissionsAll() {
            const toastStore = useToastStore();
            try {
                const { data, error } = await useFetch<IPermissionsAll[]>('/api/users/list/permissionsAll');
                this.error = error;
                if (error && error.value?.statusCode) {
                    throw error;
                }
                
                this.permissionsAll = [];
                this.permissionsAll?.push({ role:'' });
                for (let i = 0; data.value && i < data.value.length; i++) {
                    this.permissionsAll?.push({ role: data.value[i].role, permissions: data.value[i].permissions });
                }
                return true
            } catch (err: any) {
                this.error = err;
                toastStore.showAlert({
                    title: "Can Not Connect To Server",
                    showCloseButton: true,
                    timerProgressBar: true,
                    type: "error"
                });
                return false
            }
        },
    },

    persist: {
        storage: persistedState.localStorage,
    },
});
